export const textClass = (variant) => ({ 'default': 'small', 'dark': 'small text-white-50' })[variant];
export const linkClass = (variant) => ({ 'default': '', 'dark': 'text-white' })[variant];
